import { ThemeUICSSObject } from 'theme-ui';
import { responsive } from '../../util';
import getColorsAndStatesByPath from '../colors/util/getColorsAndStatesByPath';
/* IMPORT HERE */

const input: ThemeUICSSObject = {
  variant: 'text.default',
  border: '1px solid',
  borderRadius: 'default',
  padding: responsive({ 0: 3, 3: 4 }),
  '::placeholder': {
    color: '#b0b0b0',
  },
  ...getColorsAndStatesByPath('form.fields', {
    states: {
      active: false,
      hover: false,
      focus: false,
    },
  }),

  material: {
    input: {
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none',
      borderBottomColor: 'palette.border.section',

      '& + .input__underline': {
        transform: 'scale(1)',
      },

      '&:focus': {
        outline: 'none',

        '~::after': {
          animationName: 'growHorizontal',
          animationDuration: '150ms',
          animationTimingFunction: 'ease-out',
          content: '""',
          display: 'block',
          height: '0',
          outlineColor: 'palette.primary.main',
          outlineStyle: 'solid',
          outlineWidth: '1.5px',
          outlineOffset: 0,
          position: 'fixed',
          transformOrigin: 'center center',
          width: '100%',
        },
      },
    },
  },
};

export default input;
